import { AppPageLayout } from "@/components/common/AppPageLayout";
import { useTemplatesCopy } from "@/features/i18n/templatesCopy";
import { hooks as h } from "@/hooks";
import { createFileRoute, Outlet } from "@tanstack/react-router";

const New = () => {
    const copy = useTemplatesCopy();
    h.useNav([{ route: { to: Route.to }, label: copy.templates }]);

    return (
        <AppPageLayout width="full" padding="lg" as="div">
            <Outlet />
        </AppPageLayout>
    );
};

export const Route = createFileRoute("/_app/templates")({
    component: New,
});
